// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth, sendEmailVerification } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCQDhQO_LMdSpWN8GwJPAgZjJvBgpOxom4',

  authDomain: 'indabo-6f00ff.firebaseapp.com',

  projectId: 'indabo-6f00ff',

  storageBucket: 'indabo-6f00ff.firebasestorage.app',

  messagingSenderId: '545307321836',

  appId: '1:545307321836:web:7905166a932d70505e0cc9',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)
const functions = getFunctions(app, 'us-central1')

export { app, auth, db, functions, sendEmailVerification }
export default app
